<ng-content select="[left]"></ng-content>
<mn-button #mEl size="small">
  <mn-svg name="minus" class="c-0" />
</mn-button>
<div data-ui-sound class="amount t-lg" [style.--a-w.px]="aW()" [style.--a-c]="aC()" (click)="amountClicked.emit($event)">
  @if (name(); as name) {
    <span class="name u-c c-50">{{ name }}</span>
  }
  <div>
    @if (prefix(); as prefix) {
      <span>{{ prefix }}&nbsp;</span>
    }
    @if (round()) {
      <span>{{ amount() | mnRound: "0" }}</span>
    } @else {
      <span>{{ amount() }}</span>
    }
  </div>
</div>
<mn-button #pEl size="small">
  <mn-svg name="plus" class="c-0" />
</mn-button>
<ng-content select="[right]"></ng-content>
